import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { BhiFormDialog, Button, Dropdown } from 'src/UIKit';
import { useStartJoinCampaignDialogController } from '../../controllers/JoinCampaignOfferController';
import { JoinCampaignOffer } from '../../types';

interface StartJoinCampaignDialogProps {
  offer: JoinCampaignOffer | null;
  selectedCampaignId: string | null;
  loading: boolean;
  select: (campaignId: string) => void;
  start: () => void;
  close: () => void;
}

export const StartJoinCampaignDialog: FC<StartJoinCampaignDialogProps> = ({
  offer, selectedCampaignId, loading, select, start, close,
}) => {
  const count = offer?.contactIds.length ?? 0;

  return (
    <BhiFormDialog
      open={Boolean(offer)}
      onClose={() => !loading && close()}
      closeButtonDisabled={loading}
      title="Start join campaign"
      actions={
        <>
          <Button variant="outlined" onClick={close} disabled={loading}>Skip</Button>
          <Button variant="contained" onClick={start} disabled={loading || !selectedCampaignId}>
            Start campaign
          </Button>
        </>
      }
    >
      <Typography variant="body2" color="text.secondary">
        {count === 1 ? 'The contact was' : `${count} contacts were`} added to a group with active join
        campaigns.
      </Typography>
      <Typography variant="body2" color="text.secondary" mt={1}>
        Select a campaign to start for {count === 1 ? 'this contact' : 'these contacts'}, and
        they&apos;ll begin receiving its messages. If you don&apos;t want to start any, click Skip.
      </Typography>
      <Dropdown
        label="Campaign"
        value={selectedCampaignId}
        options={offer?.campaigns.map(c => ({ value: c.id, title: c.name }))}
        onChange={(_, value) => select(value)}
        disabled={loading}
      />
    </BhiFormDialog>
  );
};

/** Mounted once for the whole app, so it outlives the modal that added the contacts to groups. */
export const StartJoinCampaignDialogHost: FC = () => {
  const controller = useStartJoinCampaignDialogController();
  return <StartJoinCampaignDialog {...controller} />;
};
